import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ContainedButton } from 'styles/styles';

import { MfaListItem, MfaListMethodDescription, MfaListMethodTitle } from './styles';

export interface MfaRecoveryProps {
  name: React.ReactNode;
  description: React.ReactNode;
  icon: FontAwesomeIconProps['icon'];
  onView: () => void;
}

export default function MfaRecovery(props: MfaRecoveryProps) {
  const {
    icon,
    description,
    name,
    onView,
  } = props;

  return (
    <MfaListItem item>
      <Grid container flexDirection="row" justifyContent="space-between" alignContent="center">
        <Grid item>
          <Grid container flexDirection="row" alignItems="center" gap={2}>
            <Grid item>
              <FontAwesomeIcon icon={icon} size="2x" />
            </Grid>
            <Grid item>
              <Grid container flexDirection="column">
                <Grid item>
                  <Grid container flexDirection="row" alignItems="center" gap={2}>
                    <Grid item>
                      <MfaListMethodTitle>
                        {name}
                      </MfaListMethodTitle>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <MfaListMethodDescription>
                    {description}
                  </MfaListMethodDescription>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <ContainedButton onClick={onView} color="secondary">
            <FormattedMessage id="mfa_view" />
          </ContainedButton>
        </Grid>
      </Grid>
    </MfaListItem>
  );
}
